import React from "react";
import {Button, Checkbox, Form, Icon, Input} from "antd";
import {Link} from "react-router-dom";

import {connect} from "react-redux";
import AuthActions from "../appRedux/redux/Auth";
import MessageActions from "../appRedux/redux/Messages";

import IntlMessages from "util/IntlMessages";
import {message} from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import { CLIENT_SCHEMA, UNIVERSAL_FIELDS } from "../schemas/user";

const FormItem = Form.Item;

class SignUp extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const finalValue = {
        ...CLIENT_SCHEMA,
        ...UNIVERSAL_FIELDS,
        ...values
      }
      console.log("values", finalValue);
      if (!err) {
        this.props.showAuthLoader();
        this.props.userSignUp(finalValue);
      }
    });
  };

  constructor() {
    super();
    this.state = {
      email: '',
      password: ''
    }
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.user != null) {
      this.props.history.push('/');
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, message: m, isError} = this.props;
    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/* <img src='https://via.placeholder.com/272x395' alt='Neature'/> */}
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.signUpClient"/></h1>
                <p className="gx-mt-4"><IntlMessages id="app.userAuth.bySigning"/></p>
              </div>
              <div className="gx-app-logo">
                <Link to="/signupmayor">
                  <button type="default" className="gx-btn gx-btn-red gx-text-white">
                    <IntlMessages id="app.userAuth.getAccountMayor"/>
                  </button>
                </Link>
              </div>
            </div>

            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0">
                <FormItem>
                  {getFieldDecorator('name', {
                    rules: [{required: true, message: 'Por favor ingresa tu nombre completo!'}],
                  })(
                    <Input placeholder="Nombre completo"/>
                  )}
                </FormItem>

                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [{
                      required: true, type: 'email', message: 'E-mail ingresado no válido!',
                    }],
                  })(
                    <Input placeholder="Correo electrónico"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{required: true, message: 'Por favor ingresa tu contraseña!'}],
                  })(
                    <Input type="password" placeholder="Contraseña"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true,
                  })(
                    <Checkbox><IntlMessages id="appModule.iAccept"/></Checkbox>
                  )}
                  <span className="gx-link gx-signup-form-forgot"><IntlMessages
                    id="appModule.termAndCondition"/></span>
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    <IntlMessages id="app.userAuth.signUp"/>
                  </Button>
                  <span><IntlMessages id="app.userAuth.or"/></span> <Link to="/signin"><IntlMessages
                  id="app.userAuth.login"/></Link>
                </FormItem>
                {/* <div className="gx-flex-row gx-justify-content-between">
                  <span> ingresa con Google o Facebook</span>
                  <ul className="gx-social-link">
                    <li>
                      <Icon type="google" onClick={() => {
                        this.props.showAuthLoader();
                        this.props.userGoogleSignIn();
                      }}/>
                    </li>                
                  </ul>
                </div> */}
              </Form>
            </div>
            {loader &&
            <div className="gx-loader-view">
              <CircularProgress/>
            </div>
            }
            {showMessage &&( 
              isError ? 
              message.error(m) 
              :
              message.succes(m)
              )
            }
          </div>
        </div>
      </div>

    );
  }

}

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({auth, message: m, user: u}) => {
  const { loader } = auth;
  const { message, isError, showMessage } = m;
  const { user } = u;
  return { loader, message, isError, showMessage, user };
};

const mapActionsToProps = () => {
  const { 
    userSignUp,
    showAuthLoader,
    userSignInGoogle,
  } = AuthActions;
  const { hideMessage } = MessageActions;
  return { userSignUp, showAuthLoader, userSignInGoogle, hideMessage };
}

export default connect(mapStateToProps, mapActionsToProps())(WrappedSignUpForm);
